import { HrRed } from '@/components/styles/hr-styles';
import PropTypes from 'prop-types';
import { ErrorContainer } from './styles';

export const ErrorMessage = ({ icon, message, color }) => (
  <ErrorContainer color={color}>
    {icon && <span className={icon} />}
    {message}
  </ErrorContainer>
);

ErrorMessage.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.string.isRequired,
  color: PropTypes.string
};

ErrorMessage.defaultProps = {
  icon: null,
  color: HrRed
};
